var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemCircleDelivery = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2 4a1 1 0 0 1 1-1h15.111A2.88 2.88 0 0 1 21 5.875v12.25C21 19.72 19.7 21 18.111 21H6.778a2.88 2.88 0 0 1-2.89-2.875V14.64a1 1 0 1 1 2 0v3.485c0 .476.392.875.89.875H18.11a.88.88 0 0 0 .889-.875V5.875A.88.88 0 0 0 18.111 5H3a1 1 0 0 1-1-1m1 3.5a1 1 0 0 1 1-1h5a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1M3 10a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13.5 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7",
  clipRule: "evenodd"
})));
export default SvgGemCircleDelivery;